/** User-facing copy when OAuth/login cannot reach the server (API down, DNS, CORS, etc.). */
export const ADMIN_NETWORK_ERROR_MESSAGE =
  'Network error. Please check your connection.';

export function isTransientNetworkError(err) {
  if (!err || typeof err.status === 'number') return false;
  return (
    err instanceof TypeError ||
    err.name === 'TypeError' ||
    err.message === 'Failed to fetch'
  );
}
